import * as React from "react";
import Styles from "./input.module.scss";
import { resolveTestId, type DataTestIdProp } from "../../../../utils/testIdProps";

type InputProps = React.ComponentProps<"input"> &
  DataTestIdProp & {
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  className?: string;
};

export function Input({
  prefixIcon,
  suffixIcon,
  className,
  id,
  "data-testid": dataTestId,
  ...props
}: InputProps) {
  const testId = resolveTestId(id, dataTestId);

  return (
    <div
      className="input-group border rounded bg-light d-flex align-items-center"
      style={{
        borderColor: "transparent",
        transition: "border-color 0.2s ease-in-out",
      }}
    >
      {prefixIcon && (
        <span className="input-group-text bg-transparent border-0 pe-1">
          {prefixIcon}
        </span>
      )}

      <input
        {...props}
        id={id}
        data-testid={testId}
        className={`form-control border-0 bg-transparent shadow-none ${className ?? ""} ${Styles.inputValue}`}
        onFocus={(e) => {
          const parent = e.currentTarget.parentElement!;
          parent.style.borderColor = "#21FF91";
        }}
        onBlur={(e) => {
          const parent = e.currentTarget.parentElement!;
          parent.style.borderColor = "transparent";
        }}
      />

      {suffixIcon && (
        <span className="input-group-text bg-transparent border-0 ps-1 m-0 bg-info">
          {suffixIcon}
        </span>
      )}
    </div>
  );
}
